import { api } from './api';

/* ─────────── Tasas de cambio del día (`/api/tasas`) ───────────
 * Contrato de `netlify/functions/tasas.mts`. Los tipos son los de allí, a mano
 * y no importados, porque las funciones se compilan aparte.
 *
 * NO hay página en el RBAC: la tira la ve el portal entero (cualquier sesión).
 * El motivo largo está en la cabecera de la función.
 */

export interface Tasa {
  clave: 'bcv' | 'eur' | 'paralelo' | 'usdt';
  etiqueta: string;
  /** «Bs/$», «Bs/€», «Bs/USDT». */
  unidad: string;
  valor: number;
  fecha: string;
  fuente: string;
  detalle: string;
  /** Fracción contra la publicación ANTERIOR — no contra «ayer». `null` si no se pudo. */
  variacion: number | null;
  compra: number | null;
  venta: number | null;
}

export interface Tasas {
  consultado: string;
  tasas: Tasa[];
  /** Las claves que la fuente no entregó. Su ficha NO se pinta. */
  faltantes: string[];
  brecha: number | null;
  aviso: string;
}

/** La BCV de UN día (`/api/tasas?fecha=`). Los campos son los de allí. */
export interface TasaEnFecha {
  fecha: string;
  tasa: number | null;
  fecha_usada: string | null;
  origen: 'bcv' | 'sin_dato' | 'error';
  /** Ya escrito para pintarse: de dónde salió la tasa, o por qué no salió. */
  detalle: string;
}

export const tasasApi = {
  hoy: () => api.get<Tasas>('/tasas'),
  /**
   * La BCV vigente el día de un pago (usuaria, 2026-08-26: la tasa del Reporte
   * de pago sale del día de la transferencia, no del día en que se carga).
   * Contesta 200 aunque no haya cifra: entonces `tasa` es `null` y `detalle`
   * dice por qué.
   */
  enFecha: (fecha: string) => api.get<TasaEnFecha>('/tasas', { fecha }),
};
